import React from 'react';

import { useSilentIntentDetection } from './use-silent-intent-detection';

/**
 * Renderless component for the control cohort that calls the intent
 * detection API and emits analytics events without rendering any UI.
 *
 * We need intent detection analytics from the control cohort so we
 * can establish a statistically significant baseline for comparison with
 * the test cohort. Without this, we cannot measure whether intent
 * detection is positively impacting search success metrics.
 * See: https://hello.atlassian.net/wiki/spaces/jirasearch/pages/6613471377/baseline+and+treatment+in+Jira+FPS+search
 *
 * Must be mounted inside the QuickFind provider tree to access
 * analytics, bootstrap store, and VitalStats contexts.
 *
 * Delete this component when cleaning up the
 * rovo_jira_nin_fps_nlq_navigation experiment. It exists purely for
 * metrics purposes.
 */
export const SilentIntentDetection = ({
	query,
	minQueryLength,
}: {
	query: string;
	minQueryLength: number;
}): React.JSX.Element | null => {
	useSilentIntentDetection({ query, minQueryLength });
	return null;
};
